// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  motionId: __t.u64().primaryKey().name("motion_id"),
  guildId: __t.u64().name("guild_id"),
  kind: __t.string(),
  target: __t.identity(),
  amount: __t.i64(),
  text: __t.string(),
  proposer: __t.identity(),
  opensAt: __t.timestamp().name("opens_at"),
  closesAt: __t.timestamp().name("closes_at"),
  status: __t.string(),
  yes: __t.u32(),
  no: __t.u32(),
  outcome: __t.string(),
});
